/*
 * LEDS.ro product page helpers (loaded by sections/main-product.liquid, runs after theme.js).
 * - delivery estimate: working-day date range, stock state per variant, free shipping hint
 * - price badge / amount saved / product code / sticky bar kept in sync when the variant changes
 * - quick add for the "bought together" products (mini cart opens through Warehouse's product:added event)
 * - sticky add to cart bar on phones and tablets
 * - desktop gallery: keeps the selected thumbnail visible in the horizontal strip
 */
(function () {
  'use strict';

  var section = document.querySelector('.leds-product-page[data-section-type="product"]');
  if (!section) return;

  /* ---------- money ---------- */

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} lei';
    var value = (cents || 0) / 100;

    function withDelimiters(number, decimals, thousands, decimal) {
      var parts = number.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount': return withDelimiters(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(value, 2, "'", '.');
        default: return withDelimiters(value, 2, '.', ',');
      }
    });
  }

  /* ---------- delivery estimate ---------- */

  function addWorkingDays(date, days) {
    var result = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      var weekday = result.getDay();
      if (weekday !== 0 && weekday !== 6) added++;
    }
    return result;
  }

  function formatDay(date, capitalize) {
    var text;
    try {
      text = new Intl.DateTimeFormat('ro-RO', { weekday: 'short', day: 'numeric', month: 'short' }).format(date);
    } catch (error) {
      text = date.toLocaleDateString();
    }
    return capitalize ? text.charAt(0).toUpperCase() + text.slice(1) : text;
  }

  var delivery = section.querySelector('[data-leds-delivery]');
  var stockData = {};

  if (delivery) {
    try {
      stockData = JSON.parse(delivery.querySelector('[data-leds-stock-json]').textContent);
    } catch (error) {
      stockData = {};
    }

    var minDays = parseInt(delivery.getAttribute('data-min-days'), 10) || 0;
    var maxDays = Math.max(parseInt(delivery.getAttribute('data-max-days'), 10) || minDays, minDays);
    var today = new Date();
    var first = addWorkingDays(today, minDays);
    var last = addWorkingDays(today, maxDays);
    var rangeElement = delivery.querySelector('[data-leds-delivery-range]');

    if (rangeElement && minDays > 0) {
      rangeElement.textContent = minDays === maxDays ? formatDay(first, true) : formatDay(first, true) + ' – ' + formatDay(last, false);
      delivery.querySelector('[data-leds-delivery-dates]').hidden = false;
    }
  }

  function updateDelivery(variant) {
    if (!delivery) return;

    var stockText = delivery.querySelector('[data-leds-stock-text]');
    var stockLine = stockText.parentNode;
    var eta = delivery.querySelector('[data-leds-delivery-eta]');
    var info = variant ? stockData[variant.id] : null;
    var state = variant ? (info ? info.state : (variant.available ? 'in' : 'out')) : 'out';
    var text;

    switch (state) {
      case 'out': text = stockLine.getAttribute('data-text-out'); break;
      case 'backorder': text = stockLine.getAttribute('data-text-backorder'); break;
      case 'low': text = stockLine.getAttribute('data-text-low').replace('[count]', info && info.count != null ? info.count : ''); break;
      default: text = stockLine.getAttribute('data-text-in');
    }

    delivery.setAttribute('data-state', state);
    stockText.textContent = text;
    eta.hidden = state === 'out';

    var shipping = delivery.querySelector('[data-threshold]');
    if (shipping && variant) {
      var threshold = parseInt(shipping.getAttribute('data-threshold'), 10);
      shipping.querySelector('[data-leds-free-shipping-text]').textContent =
        variant.price >= threshold ? shipping.getAttribute('data-text-free') : shipping.getAttribute('data-text-from');
    }
  }

  /* ---------- price badge, savings, product code, sticky bar ---------- */

  var stickyBar = section.querySelector('[data-leds-sticky-buy]');

  function updatePriceExtras(variant) {
    var badge = section.querySelector('[data-leds-discount]');
    var savings = section.querySelector('[data-leds-savings]');
    var onSale = variant && variant.compare_at_price > variant.price;

    if (badge) {
      badge.hidden = !onSale;
      if (onSale) badge.textContent = '−' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
    }

    if (savings) {
      savings.hidden = !onSale;
      if (onSale) savings.querySelector('[data-leds-savings-amount]').textContent = formatMoney(variant.compare_at_price - variant.price);
    }

    var sku = section.querySelector('[data-leds-sku]');
    if (sku && variant && variant.sku) sku.textContent = variant.sku;

    if (stickyBar) {
      var stickyButton = stickyBar.querySelector('[data-leds-sticky-add]');
      if (variant) stickyBar.querySelector('[data-leds-sticky-price]').textContent = formatMoney(variant.price);
      stickyButton.disabled = !variant || !variant.available;
      stickyButton.textContent = variant && variant.available
        ? window.languages.productFormAddToCart
        : (variant ? window.languages.productFormSoldOut : window.languages.productFormUnavailable);
    }
  }

  section.addEventListener('variant:changed', function (event) {
    var variant = event.detail ? event.detail.variant : null;
    updateDelivery(variant);
    updatePriceExtras(variant);
  });

  /* ---------- quick add (bought together) ---------- */

  section.addEventListener('click', function (event) {
    var button = event.target.closest('[data-leds-quick-add]');
    if (!button || button.disabled) return;

    event.preventDefault();
    button.disabled = true;
    button.classList.add('is-loading');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(button.getAttribute('data-leds-quick-add'), 10), quantity: 1 })
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      button.classList.remove('is-loading');

      if (response.ok) {
        button.classList.add('is-added');
        button.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: null, quantity: 1 } }));
        setTimeout(function () {
          button.classList.remove('is-added');
          button.disabled = false;
        }, 1800);
      } else {
        button.disabled = false;
        response.json().then(function (content) {
          window.alert(content.description || content.message || 'Eroare');
        }).catch(function () {});
      }
    }).catch(function () {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      button.classList.remove('is-loading');
      button.disabled = false;
    });
  });

  /* ---------- sticky add to cart (phones/tablets) ---------- */

  var mainButton = section.querySelector('.product-form__add-button');

  if (stickyBar && mainButton) {
    var mobileQuery = window.matchMedia('(max-width: 999px)');
    var ticking = false;

    // Shown once the main button has scrolled above the viewport. A scroll listener rather than an
    // IntersectionObserver: a jump from below the button to above it (or back) never intersects it.
    function updateSticky() {
      ticking = false;
      var rect = mainButton.getBoundingClientRect();
      var visible = mobileQuery.matches && rect.height > 0 && rect.bottom < 0;
      stickyBar.classList.toggle('is-visible', visible);
      document.documentElement.classList.toggle('leds-sticky-buy-visible', visible);
    }

    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateSticky);
      }
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    updateSticky();

    stickyBar.querySelector('[data-leds-sticky-add]').addEventListener('click', function () {
      var button = section.querySelector('.product-form__add-button');
      if (button && !button.disabled) button.click();
    });
  }

  /* ---------- desktop gallery: selected thumbnail stays visible ---------- */

  var thumbnailList = section.querySelector('.product-gallery__thumbnail-list');

  if (thumbnailList && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (window.matchMedia('(max-width: 999px)').matches) return;
      var selected = thumbnailList.querySelector('.product-gallery__thumbnail.is-nav-selected');
      if (!selected || thumbnailList.scrollWidth <= thumbnailList.clientWidth) return;

      var left = selected.offsetLeft - (thumbnailList.clientWidth - selected.offsetWidth) / 2;
      thumbnailList.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }).observe(thumbnailList, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }
})();
